const header = document.getElementById('header');
const navbar = document.getElementById('navigation');
const mobileSearch = document.getElementById('quicksearch-mobile');
const quicksearchMobileTrigger = document.getElementById(
  'quick-search-mobile-trigger-wrapper'
);
const body = document.body;
const PAGE_TOP_OFFSET = 125;

// adds a class to style header when user has scrolled down from top
if (header) {
  const headerElement = document.getElementById('header');
  window.addEventListener('scroll', function () {
    var scrollPosition = document.documentElement.scrollTop;
    if (scrollPosition > 0) {
      headerElement.classList.add('-top-[22px]');
      headerElement.classList.remove('top-0');
      body.classList.add('scrolled_down');
      quicksearchMobileTrigger?.classList.remove('initially-hidden');
    } else {
      headerElement.classList.remove('-top-[22px]');
      headerElement.classList.add('top-0');
      body.classList.remove('scrolled_down');
    }
  });
}
// adds en removes classes depending on scroll upp or down
if (navbar) {
  var lastScrollTop = 0;
  var expandHeaderScroll = 0;
  window.addEventListener('scroll', function () {
    var scrollTop = document.documentElement.scrollTop;
    if (
      scrollTop > lastScrollTop &&
      scrollTop > PAGE_TOP_OFFSET &&
      !document.body.className.includes('overlay--MegaMenu')
    ) {
      //Scrolled down
      navbar.classList.add('header__navigation--hidden');
      mobileSearch.classList.add('quicksearch--hidden');
      quicksearchMobileTrigger?.classList.remove('hidden');
      header.classList.remove('header__menu-visible');
    } else if (
      scrollTop < lastScrollTop &&
      !document.body.classList.contains('disable-mega-menu')
    ) {
      //scrolled up
      navbar.classList.remove('header__navigation--hidden');
      header.classList.add('header__menu-visible');
      mobileSearch.classList.remove('quicksearch--hidden');
      quicksearchMobileTrigger?.classList.add('hidden');
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
}
